import { awsConfig } from '../aws-config';

export async function refreshTokenIfNeeded(): Promise<string | null> {
  const token = localStorage.getItem('meppy_token');
  const refreshToken = localStorage.getItem('meppy_refresh_token');
  
  if (!token || !refreshToken) {
    return null;
  }

  // Check if token is expired
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => 
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));
    const decoded = JSON.parse(jsonPayload);
    
    const expiryTime = decoded.exp * 1000; // Convert to milliseconds
    const now = Date.now();
    const fiveMinutes = 5 * 60 * 1000;
    
    // Refresh if token expires in less than 5 minutes
    if (expiryTime - now < fiveMinutes) {
      const tokenUrl = `https://${awsConfig.userPoolDomain}.auth.${awsConfig.region}.amazoncognito.com/oauth2/token`;
      const clientSecret = '1okldvj8s5lshnhb7stn59q2alk5gtpocitvki1upkhnnejmvovk';
      const credentials = btoa(`${awsConfig.userPoolClientId}:${clientSecret}`);
      
      const response = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Basic ${credentials}`,
        },
        body: new URLSearchParams({
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        }),
      });

      if (response.ok) {
        const tokens = await response.json();
        const newIdToken = tokens.id_token;
        localStorage.setItem('meppy_token', newIdToken);
        return newIdToken;
      } else {
        // Refresh failed, clear tokens
        localStorage.removeItem('meppy_token');
        localStorage.removeItem('meppy_refresh_token');
        return null;
      }
    }
    
    return token;
  } catch (error) {
    console.error('Token refresh error:', error);
    return token;
  }
}
